module.exports = __webpack_public_path__ + "static/alarm-d8940fc0a2b48e17372f655f22e293e5.wav";